import { createVNode as n, mergeProps as d } from "vue";
import e from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DownloadOutlinedStandard.js";
import l from "../components/PfIcon.js";
const t = (o, r) => {
  const a = {
    ...o,
    ...r.attrs
  };
  return n(l, d(a, {
    icon: e
  }), null);
};
t.displayName = "DownloadOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
